"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

exports.handleCoinAuthRedirect = function () {
  try {
    if (window.opener && window.opener.closeAuthWindow) {
      var token = (window.location.href.split('token=')[1] || '').split('&')[0];

      if (token) {
        window.opener.closeAuthWindow(token);
      } else {
        window.opener.closeAuthWindow();
      }
    }
  } catch (e) {
    console.log('coin redirect error', e);
  }
};

exports.CoinAuth = function (_a) {
  var url = _a.url,
      _b = _a.width,
      width = _b === void 0 ? 300 : _b,
      _c = _a.height,
      height = _c === void 0 ? 400 : _c,
      onSuccess = _a.onSuccess,
      onError = _a.onError,
      children = _a.children,
      renderButton = _a.renderButton,
      props = __rest(_a, ["url", "width", "height", "onSuccess", "onError", "children", "renderButton"]);

  var _d = react_1.useState(false),
      loading = _d[0],
      setLoading = _d[1];

  var openPopup = function openPopup() {
    var left = Number(window.screen.width / 2 - width / 2);
    var top = Number(window.screen.height / 2 - height / 2);
    var opts = "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left;
    var authWindow = window.open(url, '', opts);
    setLoading(true);

    if (authWindow) {
      var intervalId_1 = setInterval(function () {
        if (authWindow.closed) {
          clearInterval(intervalId_1);
          setLoading(false);
        }
      }, 2000);

      window['closeAuthWindow'] = function (token) {
        clearInterval(intervalId_1);
        setLoading(false);
        authWindow.close();
        if (token && onSuccess) onSuccess(token);
      };
    }

    return false;
  };

  return react_1["default"].createElement("div", __assign({
    onClick: renderButton ? undefined : openPopup
  }, props), renderButton ? renderButton({
    loading: loading
  }, {
    openPopup: openPopup
  }) : children);
};